import React, { useState, useEffect } from 'react';
import { Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import 'animate.css';
import { useLocation } from 'react-router-dom';

const ProjectTabsWeb = ({ all, prof, perso, side }) => {
  const [tabSwitchClass, setTabSwitchClass] = useState("left");
  const [activeTab, setActiveTab] = useState(() => localStorage.getItem('activeTab') || 'first');
  const [animationClass, setAnimationClass] = useState("");
  const location = useLocation();

  useEffect(() => {
    const wasOnProjects = localStorage.getItem('wasOnProjects') === 'true';
    const storedTab = localStorage.getItem('activeTab');
    if (wasOnProjects && storedTab) {
      handleSelect(storedTab);
    } else if (!activeTab) {
      setActiveTab('first');
    }
    localStorage.setItem('wasOnProjects', 'false');
  }, [location, activeTab]);

  // Update tabSwitchClass whenever activeTab changes
  useEffect(() => {
    setTabSwitchClass(
      activeTab === "first"
        ? "left"
        : activeTab === "second"
        ? "center"
        : activeTab === "third"
        ? "right"
        : "far-right"
    );
  }, [activeTab]);

  const handleSelect = (key) => {
    const tabKey = key || 'first';
    setTabSwitchClass(tabKey === "first" ? "left" : tabKey === "second" ? "center" : tabKey === "third" ? "right" : "far-right");
    setActiveTab(tabKey);
    setAnimationClass("popup");
    localStorage.setItem('activeTab', tabKey);
    setTimeout(() => {
      setAnimationClass("");
    }, 300);
  };

  return (
    <Tab.Container id="projects-tabs" activeKey={activeTab || 'first'} onSelect={handleSelect}>

      <Nav className='nav-pills-parent justify-content-center align-items-center'>
        <Nav variant="pills" className={`nav-pills justify-content-center align-items-center tab-switch ${tabSwitchClass}`} id="pills-tab">
          <Nav.Item className={`${tabSwitchClass === "left" ? 'nav-item-active' : ''} ${activeTab === "first" ? animationClass : ''}`}>
            <Nav.Link as="button" eventKey="first" title="Featured Projects">
              <p>All projects</p>
            </Nav.Link>
          </Nav.Item>

          <Nav.Item className={`${tabSwitchClass === "center" ? 'nav-item-active' : ''} ${activeTab === "second" ? animationClass : ''}`}>
            <Nav.Link as="button" eventKey="second" title="Professional Projects">
              <p>Professional</p>
            </Nav.Link>
          </Nav.Item>

          <Nav.Item className={`${tabSwitchClass === "right" ? 'nav-item-active' : ''} ${activeTab === "third" ? animationClass : ''}`}>
            <Nav.Link as="button" eventKey="third" title="Personal Projects">
              <p>Personal</p>
            </Nav.Link>
          </Nav.Item>

          <Nav.Item className={`${tabSwitchClass === "far-right" ? 'nav-item-active' : ''} ${activeTab === "fourth" ? animationClass : ''}`}>
            <Nav.Link as="button" eventKey="fourth" title="Side Projects">
              <p>Side projects</p>
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </Nav>

      <Tab.Content>
        <Tab.Pane eventKey="first">
          <div id="proj-first">
            <div className='project-posts'>
              {all.map((project, index) => (
                <ProjectCard
                  key={index}
                  {...project}
                  delay={index * 0.05}
                />
              ))}
            </div>
          </div>
        </Tab.Pane>
        <Tab.Pane eventKey="second">
          <div id="proj-second">
            {/* <div className='project-posts-title'>
              <Divider width={100} />
              <h4>Professional Projects</h4>
            </div> */}
            <div className='project-posts'>
              {prof.map((project, index) => (
                <ProjectCard
                  key={index}
                  {...project}
                  delay={index * 0.05}
                />
              ))}
            </div>
          </div>
        </Tab.Pane>
        <Tab.Pane eventKey="third">
          <div id="proj-third">
            {/* <div className='project-posts-title'>
              <Divider width={100} />
              <h4>Personal Projects</h4>
            </div> */}
            <div className='project-posts'>
              {perso.map((project, index) => (
                <ProjectCard
                  key={index}
                  {...project}
                  delay={index * 0.05}
                />
              ))}
            </div>
          </div>
        </Tab.Pane>
        <Tab.Pane eventKey="fourth">
          <div id="proj-fourth">
            {/* <div className='project-posts-title'>
              <Divider width={100} />
              <h4>Side Projects</h4>
            </div> */}
            <div className='project-posts'>
              {side.map((project, index) => (
                <ProjectCard
                  key={index}
                  {...project}
                  delay={index * 0.05}
                />
              ))}
            </div>
          </div>
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  );
};

export default ProjectTabsWeb;
